/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/
import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { removeToken } from 'common/auth'
import store from 'store'

// 白名单
const whiteList = ['/login', '/activation', '/registry', '/forget-password', '/protocol', '/privacy', '/un-active-forgot', '/un-active', '/bind-success']
const verifyList = ['/user/bind-email', '/user/bind-mobile', '/user/verify-email', '/user/verify-mobile', '/user/verify-identity']

/**
* 获取URL参数
*
* @param {*} paramName
* @returns
*/
// function getParam(paramName) {
//     // console.log(location,decodeURIComponent(location.search))
//     let paramValue = ''
//     let isFound = !1
//     if (location.search.indexOf('?') === 0 && location.search.indexOf('=') > 1) {
//         let arrSource = location.search.substring(1, location.search.length).split('&')
//         let i = 0
//         // eslint-disable-next-line no-sequences
//         while (i < arrSource.length && !isFound) arrSource[i].indexOf('=') > 0 && arrSource[i].split('=')[0].toLowerCase() === paramName.toLowerCase() && (paramValue = arrSource[i].split('=')[1], isFound = !0), i++
//     }
//     // eslint-disable-next-line no-sequences
//     return paramValue === '' && (paramValue = null), paramValue
// }

router.beforeEach((to, from, next) => {
    NProgress.start()
    removeToken()
    // next()

    if (whiteList.includes(to.path)) {
        next()
    } else if (verifyList.includes(to.path)) {
        const userInfo = store.getters['user/userInfo']
        if (userInfo === null) {
            next('/forget-password')
        } else {
            next()
        }
    } else if (to.path === '/user/new-password') {
        if (from.path === '/') {
            next('/user/verify-identity')
        } else {
            next()
        }
    } else {
        removeToken()
        next('/login')
        NProgress.done()
    }
})

router.afterEach(() => {
    NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js